import gql from 'graphql-tag'

// getTracking
export const GET_DEVICES = gql`
  query Devices($filter: GetDevicesFilter) {
    devices(filter: $filter) {
      isSuccessful
      message
      devices {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorType
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`

export const GET_DEVICE_HISTORIES = gql`
query DeviceHistories($filter: DeviceHistoriesFilter) {
  deviceHistories(filter: $filter) {
    isSuccessful
    message
    deviceHistories {
      imei
      companyId
      licensePlate
      phoneNo
      activeOn
      inactiveOn
    }
  }
}
`

export const GET_DEVICE_LOGS = gql`
query DeviceLogs($filter: DeviceLogsFilter) {
  deviceLogs(filter: $filter) {
    isSuccessful
    message
    deviceLogs {
      messageOn
      vehicleId
      userId
      message
      type
      title
      name
      licensePlate
      description
    }
  }
}
`

export const DEVICE_MUTATION_CREATE = gql`
  mutation CreateDevice($input: CreateDeviceInput!) {
    createDevice(input: $input) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorCode
        vendorName
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`

export const DEVICE_MUTATION_UPDATE = gql`
mutation UpdateDevice($input: UpdateDeviceInput!) {
  updateDevice(input: $input) {
    isSuccessful
    message
    device {
      imei
      identifier
      companyId
      vehicleId
      phoneNo
      ip
      port
      deviceCode
      deviceName
      vendorType
      portKernel
      activeOn
      status
      domain
      database
      username
      password
    }
  }
}
`

export const DEVICE_MUTATION_DELETE = gql`
  mutation UpdateDevice($imei: String!) {
    updateDevice(imei: $imei, data: {status:2}) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorCode
        vendorName
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`
